import moment from 'moment';

export default {
    install(Vue){
        Vue.filter('dateTime', function(value){
            return moment(value).format('YYYY-MM-DD HH:mm:ss');
        });
    }
}


// WEBPACK FOOTER //
// ./src/filters.js